import { LEFT_PANEL_HEIGHT_PX } from '../constants';

export const ContractListLoadingSkeleton = () => {
  return (
    <div
      className="divide-info-200 divide-y"
      style={{ height: LEFT_PANEL_HEIGHT_PX }}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="sr-only">Loading contracts...</span>
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="flex items-center justify-between gap-3 px-1 py-2.5">
          <div className="h-5 flex-1 animate-pulse rounded bg-slate-200" />
          <div className="h-7 w-[50px] animate-pulse rounded bg-slate-200" />
        </div>
      ))}
    </div>
  );
};
